import { SxProps, Theme } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
import React from "react";

interface IDateCalendarProps {
	title?: string;
	views?: ("year" | "month")[];
	openTo?: "year" | "month";
	value?: any;
	format?: string;
	disableFuture?: boolean;
	loading?: boolean;
	disabled?: boolean;
	sx?: SxProps<Theme>;
	onChange?: (value: Date | null) => void;
}

export const DateViewMonthYear: React.FC<IDateCalendarProps> = ({
	value = null,
	title = "",
	openTo = "month",
	views = ["year", "month"],
	onChange,
	disableFuture = true,
	loading = false,
	disabled = false,
	format = "MM/YYYY",
	sx = {},
}) => {
	// Configurar o locale do dayjs para 'pt-br'
	dayjs.locale("pt-br");

	return (
		<LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
			<DatePicker
				value={value}
				views={views}
				openTo={openTo}
				onChange={(newValue) => {
					// Converter valor para tipo Date e chamar onChange
					onChange?.(newValue ? newValue.toDate() : null);
				}}
				disableFuture={disableFuture}
				disabled={disabled}
				format={format}
				slotProps={{
					textField: {
						label: title || undefined,
						size: "small",
						fullWidth: true,
						InputLabelProps: { shrink: true },
					},
				}}
				sx={{
					"& .MuiInputBase-root": {
						fontSize: "16px",
					},
					"& .MuiFormLabel-root": {
						fontSize: "16px",
					},
					...sx,
				}}
			/>
		</LocalizationProvider>
	);
};
